import { action } from "typesafe-actions";

import { ProofOfLifeTypes, FaceRecognitionTypes } from "./types";

export const setFaceRecognitionAction = (data: FaceRecognitionTypes) =>
  action(ProofOfLifeTypes.SET_FACE_RECOGNITION, data);
